import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type EpisodeTypeStringEnum =
  | "depressive"
  | "hypomania"
  | "mania"
  | "unspecified";

type EpisodeSeverityStringEnum = "light" | "medium" | "severe";

export default class ThymicEpisodeOccurredJournalEvent extends JournalEvent {
  static override type = "thymic-episode-occurred-journal-event";

  @attr("string") declare episodeType: EpisodeTypeStringEnum;

  @attr("string") declare episodeSeverity: EpisodeSeverityStringEnum;

  @attr("boolean", {
    allowNull: true
  })
  declare withAnxiousDistress: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withMixedCharacteristics: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withPsychoticCongruentWithMood: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withPsychoticNotCongruentWithMood: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withCatatonia: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withMelancholicCharacteristics: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withOnsetDuringPeripartum: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare withAtypicalCharacteristics: boolean;

  @attr("string") declare episodeDuration: string;

  @attr("boolean", {
    allowNull: true
  })
  declare hospitalization: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare tsPresence: boolean;

  @attr("string") declare commentary: string;

  static override validations(intl: IntlService) {
    return {
      episodeType: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.thymic-episode-occurred-journal-event.episode-type"
          )
        }),
        validateInclusion({
          list: ["depressive", "hypomania", "mania", "unspecified"],
          description: intl.t(
            "validations.thymic-episode-occurred-journal-event.episode-type"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.thymic-episode-occurred-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      episodeSeverity: validateInclusion({
        list: ["light", "medium", "severe"],
        allowBlank: true,
        description: intl.t(
          "validations.thymic-episode-occurred-journal-event.episode-severity"
        )
      })
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "thymicEpisodeOccurredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "thymic-episode-occurred-journal-event": ThymicEpisodeOccurredJournalEvent;
  }
}
